// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactFeather from "react-feather";
import * as Pages$Coronate from "./Pages.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "./Externals/Externals.res.js";
import * as Data_Config$Coronate from "./Data/Data_Config.res.js";
import * as Data_Scoring$Coronate from "./Data/Data_Scoring.res.js";

function HelpDialogs$BaseDialog(props) {
  var match = props.state;
  var setFalse = match.setFalse;
  return JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
              isOpen: match.state,
              onDismiss: setFalse,
              ariaLabel: props.ariaLabel,
              children: [
                JsxRuntime.jsx("button", {
                      children: "Done",
                      className: "button-micro",
                      onClick: (function (param) {
                          setFalse();
                        })
                    }),
                props.children
              ],
              className: ""
            });
}

function HelpDialogs$Pairing(props) {
  var config = props.config;
  return JsxRuntime.jsxs(HelpDialogs$BaseDialog, {
              state: props.state,
              ariaLabel: props.ariaLabel,
              children: [
                JsxRuntime.jsx("p", {
                      children: "A Swiss-system tournament is effective when you carefully pair players according to\n          certain priorities. Calculating the ideal pairings by hand can be complicated, so that's\n          where auto-pair comes in."
                    }),
                JsxRuntime.jsx("p", {
                      children: "These are the pairing rules:"
                    }),
                JsxRuntime.jsxs("ol", {
                      children: [
                        JsxRuntime.jsx("li", {
                              children: "Two players should not play each other more than once per tournament."
                            }),
                        JsxRuntime.jsx("li", {
                              children: "Players with the same score should be paired."
                            }),
                        JsxRuntime.jsx("li", {
                              children: "Players in the top \"half\" of ratings should be paired with players in the bottom \"half\"\n            of ratings. (This gives the chance for an upset!)"
                            }),
                        JsxRuntime.jsxs("li", {
                              children: [
                                "Players should each alternate playing ",
                                Data_Config$Coronate.aliasToStringWhite(config),
                                " and ",
                                Data_Config$Coronate.aliasToStringBlack(config),
                                " pieces. To facilitate this, each\n            player should be paired with someone who is due the opposite color that they are due."
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsx("p", {
                      children: "Rule number one is the most important rule, and rule number two is a close second. Without\n          them, the whole Swiss system loses its effectiveness."
                    }),
                JsxRuntime.jsx("p", {
                      children: "Rules three and four are valuable because they keep the games fair and interesting, but\n          they are less important."
                    }),
                JsxRuntime.jsx("p", {
                      children: "You will never be able to perfectly follow all of these rules for every pairing in every\n          round. Auto-pair does its best to follow as many as it can, starting with the most\n          important."
                    }),
                JsxRuntime.jsx("p", {
                      children: "Auto-pair calculates an \"ideal\" for every possible match based on these rules, and then\n          finds the combination of pairings that has the highest average ideal for the whole round.\n          This means that sometimes it will not use one obvious pairing if it can use another\n          combination of pairings that is overall more ideal."
                    }),
                JsxRuntime.jsx("p", {
                      children: "When you manually pair a player, the auto-pair \"ideal\" score for each other player will\n          display as a percentage. Think of this as a strong suggestion."
                    })
              ]
            });
}

var Pairing = {
  make: HelpDialogs$Pairing
};

function HelpDialogs$SwissTournament(props) {
  return JsxRuntime.jsxs(HelpDialogs$BaseDialog, {
              state: props.state,
              ariaLabel: props.ariaLabel,
              children: [
                JsxRuntime.jsxs("p", {
                      children: [
                        "Coronate uses ",
                        JsxRuntime.jsxs("a", {
                              children: [
                                "Swiss-system tournaments ",
                                JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                              ],
                              href: "https://en.wikipedia.org/wiki/Swiss-system_tournament"
                            }),
                        ". It sets a fixed number of rounds that will be smaller than the number of players. It\n          pairs players according to their scores, but without any two players meeting twice."
                      ]
                    }),
                JsxRuntime.jsx("p", {
                      children: "A Swiss tournament produces a single first-place winner but many ties for second, third,\n          and so on. (If games are drawn, there may be ties for first as well.) It uses several\n          tie-breaking strategies to determine the final standings."
                    }),
                JsxRuntime.jsxs("p", {
                      children: [
                        "To calculate how many rounds your tournament will require for a certain number of players,\n          you can refer to the ",
                        JsxRuntime.jsxs(Router$Coronate.Link.make, {
                              children: [
                                Pages$Coronate.TimeCalculator.title,
                                " page"
                              ],
                              to_: "TimeCalculator"
                            }),
                        "."
                      ]
                    })
              ]
            });
}

var SwissTournament = {
  make: HelpDialogs$SwissTournament
};

function HelpDialogs$TieBreaks(props) {
  return JsxRuntime.jsxs(HelpDialogs$BaseDialog, {
              state: props.state,
              ariaLabel: props.ariaLabel,
              children: [
                JsxRuntime.jsx("p", {
                      children: "A Swiss-system tournament will always produce ties. These are tie-breaking strategies\n          adopted from the USCF rulebook. You may disable or adjust their priorities for each\n          tournament."
                    }),
                JsxRuntime.jsxs("dl", {
                      children: [
                        JsxRuntime.jsx("dt", {
                              children: Data_Scoring$Coronate.TieBreak.toPrettyString("Median"),
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: "Sum all of each player's opponents' scores, discarding the highest and lowest."
                            }),
                        JsxRuntime.jsx("dt", {
                              children: Data_Scoring$Coronate.TieBreak.toPrettyString("Solkoff"),
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: "The same as modified median, except without discarding any scores."
                            }),
                        JsxRuntime.jsx("dt", {
                              children: Data_Scoring$Coronate.TieBreak.toPrettyString("Cumulative"),
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: "Sum each player's cumulative, or \"running,\" score for each round. This favors players\n            who scored earlier. (Presumably, they faced harder opponents later.)"
                            }),
                        JsxRuntime.jsx("dt", {
                              children: Data_Scoring$Coronate.TieBreak.toPrettyString("CumulativeOfOpposition"),
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: "Sum the cumulative of each player's opponents' scores."
                            }),
                        JsxRuntime.jsx("dt", {
                              children: Data_Scoring$Coronate.TieBreak.toPrettyString("MostBlack"),
                              className: "title-20"
                            }),
                        JsxRuntime.jsx("dd", {
                              children: "Count the matches where each player used black pieces."
                            })
                      ]
                    })
              ]
            });
}

var TieBreaks = {
  make: HelpDialogs$TieBreaks
};

export {
  Pairing ,
  SwissTournament ,
  TieBreaks ,
}
/* react-feather Not a pure module */
